import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M8.109 3.958h-.417A3.333 3.333 0 0 0 4.36 7.292v.416m3.749 8.334h-.417a3.333 3.333 0 0 1-3.333-3.334v-.416m8.333-8.334h.417a3.333 3.333 0 0 1 3.333 3.334v.416m-3.75 8.334h.417a3.333 3.333 0 0 0 3.333-3.334v-.416" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M9.15 8.333a.417.417 0 1 1-.833 0 .417.417 0 0 1 .833 0Zm3.334 0a.417.417 0 1 1-.834 0 .417.417 0 0 1 .834 0Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /> <path d="M7.692 10.625s.208 2.083 2.708 2.083 2.709-2.083 2.709-2.083" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);